import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL + "/CodeLevel";

export const getCodeLevelList = () => {
  return axios.get(`${api_base_url}`).then((res) => {
    return res.data;
  });
};

//Add CodeLevel
export const addCodeLevel = async (newData) => {
  return await axios.post(`${api_base_url}`, newData[0]);
};

//Delete CodeLevel
export const deleteCodeLevel = async (ids) => {
  await axios.delete(`${api_base_url}/CodeLevel`, {
    data: ids,
  });
};

//Update CodeLevel
export const updateCodeLevel = async (updatedCodeLevel) => {
  return await axios.put(`${api_base_url}`, {
    ...updatedCodeLevel,
  });
};

export const getCodeLevels = (codeLevelId = null) => {
  return axios
    .get(`${api_base_url}/GetCodeLevels/`, codeLevelId)
    .then((res) => {
      return res.data;
    });
};
